export interface DateOptionsProps {
  label: string
  value: string
}

export interface DateFilterOptionsProps {
  [artifact: string]: DateOptionsProps[] | undefined
}

const defaultDateFilterOptions: DateOptionsProps[] = [
  { label: 'Em qualquer data', value: 'any' },
  { label: 'Últimas 24 horas', value: '1dia' },
  { label: 'Última semana', value: '7dias' },
  { label: 'Último mês', value: '30dias' },
  { label: 'Último ano', value: '365dias' },
  { label: 'Selecionar período', value: 'custom' },
]

const jurisDateFilterOptions: DateOptionsProps[] = [
  { label: 'Em qualquer data', value: 'any' },
  { label: 'Último mês', value: '30dias' },
  { label: 'Último ano', value: '365dias' },
  { label: 'Últimos 2 anos', value: '730dias' },
  { label: 'Últimos 3 anos', value: '1095dias' },
  { label: 'Últimos 5 anos', value: '1825dias' },
  { label: 'Selecionar período', value: 'custom' },
]

const allDateFilterOptions = [...defaultDateFilterOptions, ...jurisDateFilterOptions]

const allUniqueDateFilter = [...new Set(allDateFilterOptions.map(({ value }) => value))].map(
  (value) => ({
    value,
    label: allDateFilterOptions.find((option) => option.value === value)?.label,
  })
)

const dateRangeFilterOptionsMap = allUniqueDateFilter.reduce(
  (acc, { label, value }) => acc.set(value.toLowerCase(), { label }),
  new Map()
)

const getDateRangeType = (dateRangeOptionValue: string): string | undefined => {
  switch (dateRangeOptionValue) {
    case '1dia':
      return 'last_day'
    case '7dias':
      return 'last_week'
    case '30dias':
      return 'last_month'
    case '365dias':
      return 'last_year'
    case '730dias':
      return 'last_two_years'
    case '1095dias':
      return 'last_three_years'
    case '1825dias':
      return 'last_five_years'
    default:
      return undefined
  }
}

const dateFilterOptions: DateFilterOptionsProps = {
  general: defaultDateFilterOptions,
  'artigos-noticias': defaultDateFilterOptions,
  artigos: defaultDateFilterOptions,
  noticias: defaultDateFilterOptions,
  jurisprudencia: jurisDateFilterOptions,
  diarios: defaultDateFilterOptions,
  pecas: defaultDateFilterOptions,
  'modelos-pecas': defaultDateFilterOptions,
  legislacao: defaultDateFilterOptions,
  'consulta-processual': undefined,
  doutrina: undefined,
}

const getDateFilterOptions = (artifact: string): DateOptionsProps[] =>
  dateFilterOptions[artifact.toLowerCase()] || []

export { dateRangeFilterOptionsMap, getDateFilterOptions, getDateRangeType }
